module.exports = __webpack_public_path__ + "files/616b623ed90e5e535f1346695544db4c.png";